import React from 'react';
import PropTypes from 'prop-types';

import { Div, Icon, Text } from '@pinpoint/design-kit';

function Title({ color, iconViewBox, icon, text, hoverColor, iconStyle, textSize }) {
  return (
    <Div d="flex" align="center">
      <Icon viewBox={iconViewBox} color={color} hoverColor={hoverColor || color} name={icon} {...iconStyle} />
      <Text
        lineHeight={textSize || 'heading'}
        m={{ l: '1.125rem', b: '0' }}
        textSize={textSize || 'heading'}
        textColor={color}
        hoverTextColor={hoverColor || color}
      >
        {text}
      </Text>
    </Div>
  );
}

Title.propTypes = {
  color: PropTypes.string.isRequired,
  iconViewBox: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  textSize: PropTypes.string,
  hoverColor: PropTypes.string,
  iconStyle: PropTypes.shape({}),
};

Title.defaultProps = {
  hoverColor: null,
  iconStyle: {},
  textSize: 'heading',
};

export default Title;
